<template>
    <div :class="[
        'input-container',
        {'valid':invalid === false},
        {'error':invalid === true || errorText.length > 0},
    ]">
        <div v-if="$slots['label'] || label.length>0" class="input-label">
            <slot name="label">
                <span v-if="label.length>0">{{ label }}</span>
                <span v-if="required" class="text-danger ms-1">*</span>
            </slot>
        </div>
        <div class="input-group">
            <slot name="prepend"></slot>
            <component :is="tag"
                       :class="[
                    'form-control',
                    'input',
                    {'valid':invalid === false},
                    {'error':invalid === true || errorText.length > 0},
                    {'form-control-lg': size === 'lg'},
                    {'form-control-sm': size === 'sm'},
                ]"
                       :type="type"
                       :placeholder="placeholder"
                       :value="modelValue"
                       :aria-invalid="invalid === true || errorText.length > 0"
                       :aria-describedby="errorText.length > 0 ? 'input-error-text' : undefined"
                       @input="$emit('update:modelValue', $event.target.value)">
                <template v-if="tag==='textarea'">{{ modelValue }}</template>
            </component>
            <slot name="append"></slot>
        </div>
        <div class="input-info" v-if="$slots['info'] || infoText.length>0">
            <slot name="info">
                <span v-if="infoText.length > 0">{{ infoText }}</span>
            </slot>
        </div>
        <div class="input-error" v-if="$slots['error'] || errorText.length>0" id="input-error-text">
            <slot name="error">
                <span v-if="errorText.length > 0">{{ errorText }}</span>
            </slot>
        </div>
    </div>
</template>

<script>
/**
 * Simple input component.
 * Slots:
 * info - informative text slot
 * error - error text slot
 * append-addon - input group right addon
 * prepend-addon - input group left addon
 */
export default {
    name: "UInput",
    emits: ['update:modelValue'],
    data() {
        return {}
    },
    props: {
        type: {
            type: String,
            default: 'text',
            description: 'Input type attribute',
            required: false,
        },
        modelValue: {
            type: [String, Number],
            description: 'Input value attribute',
            required: false,
        },
        name: {
            type: String,
            description: 'Input name attribute',
            required: false,
        },
        placeholder: {
            type: String,
            default: '',
            description: 'Input placeholder value',
            required: false,
        },
        invalid: {
            type: Boolean,
            default: null,
            description: 'Whether input is invalid and error message must be shown. By default it is set to null so no styling is added.',
            required: false,
        },
        errorText: {
            type: String,
            default: '',
            description: 'Error message',
            required: false,
        },
        infoText: {
            type: String,
            default: '',
            description: 'Info message',
            required: false,
        },
        label: {
            type: String,
            default: '',
            description: 'Label text',
            required: false,
        },
        size: {
            type: String,
            default: '',
            description: 'Input size: lg - for large, sm - for small',
            required: false,
        },
        required: {
            type: Boolean,
            default: true,
            description: 'Whether filling input is required or no',
            required: false,
        },
        tag: {
            type: String,
            default: 'input',
            description: 'Tag for input element. Can be either input or textarea',
            required: false,
        }
    },
}
</script>

<style scoped>

</style>
